<div class="main-content">
  <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <h4 class="title">Tableau de bord</h4>
        </div>
        <div class="col-md-6">
          <div class="pull-right">
            <!--<app-info-button classes="btn btn-primary btn-round btn-round-pro" text="lele" title="butttttt"></app-info-button>-->
          </div>
        </div>
      </div>
    <div class="mt-3">
      <div class="header text-center">

      </div>

      <div class="row" [ngClass]="{'first-charts': !allRight && !droit.travailleursUtilisation}">

        <div class="col-md-6" *ngIf="allRight || droit.documentsGenerauxUtilisation">
          <div class="card card-chart">
            <div class="card-header card-header-icon card-header-danger">

              <h4 class="card-title">Documents généraux site</h4>
            </div>
            <div class="card-body" >
              <button class="btn btn-default" *ngIf="documentNeedSetting  && (this.allRight || this.droit.documentsGenerauxParametrage)"
              [routerLink]="documentPametrageRoute">Cliquez ici pour paramétrer</button>
              <div *ngIf="!documentNeedSetting" id="chart1" class="ct-chart"></div>
            </div>
          </div>
        </div>

        <div class="col-md-6" *ngIf="allRight || droit.equipementsInstallationsUtilisation">
          <div class="card card-chart">
            <div class="card-header card-header-icon card-header-danger">
              <h4 class="card-title">Equipements et installations</h4>
            </div>
            <div class="card-body" >
              <button class="btn btn-default" *ngIf="equipmentNeedSetting && (this.allRight || this.droit.equipementsInstallationsParametrage)"
              [routerLink]="equipementPametrageRoute">Cliquez ici pour paramétrer</button>
              <div id="chart2" *ngIf="!equipmentNeedSetting" class="ct-chart"></div>
            </div>
          </div>
        </div>


      </div>
      <div class="row">
        <div class="col-md-6 offset-md-3"  *ngIf="allRight || droit.travailleursUtilisation">
            <div class="card card-chart">
              <div class="card-header card-header-icon card-header-danger">
                <h4 class="card-title">Travailleurs</h4>
              </div>
              <div class="card-body">
                <button class="btn btn-default" *ngIf="travailleurNeedSetting && (this.allRight || this.droit.travailleursParametrage)"
                [routerLink]="travailleurPametrageRoute">Cliquez ici pour paramétrer</button>
                <div id="chart3"  *ngIf="!travailleurNeedSetting" class="ct-chart"></div>
              </div>
            </div>
        </div>
        <div class=" offset-md-8 col-md-4">
          <div class="card-footer mt-150">
            <p><i class="fa fa-square text-success green"></i> Conforme</p>
            <p><i class="fa fa-square text-warning"></i> Actions correctives à mener</p>
            <p><i class="fa fa-square text-danger red"></i> Critique</p>
            <p><i class="fa fa-square text-dark grey-p"></i> Non suivi / Travailleurs  non paramétrés</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
